import React from 'react';
import { PeriodLabel } from '../Data/PeriodLabels';

interface Props {
    periodLabel?: PeriodLabel;
    fallback: string | number;
}

const PeriodColumnHeader = ({ periodLabel, fallback }: Props) => {
    if (!periodLabel) return <>{fallback}</>;
    return (
        <>
            {periodLabel.label}
            <br />
            <small className="text-muted fw-normal">{periodLabel.range}</small>
        </>
    );
};

export default PeriodColumnHeader;
